// extracted by mini-css-extract-plugin
export default {"lds_roller":"Loader_lds_roller__dTQM2","lds-roller":"Loader_lds-roller__TxnBC","lds_roller_white_dots":"Loader_lds_roller_white_dots__yU-Q6"};